import { createEnv } from "@t3-oss/env-core";
import { webEnvConfig } from "./env-schema";

export const env = createEnv({
  ...webEnvConfig,
  runtimeEnv: import.meta.env,
});
